import MainTitle from '../components/MainTitle.vue';
import StoreLocatorAroundMe from '../components/StoreLocatorAroundMe.vue';
import StoreLocatorMap from '../components/StoreLocatorMap.vue';
import StoreLocatorStoreCard from '../components/StoreLocatorStoreCard.vue';
import { haversineDistance } from '../utils/Geolocation';
import Url from '../StoreLocator/Url';
import Geocoding from '../StoreLocator/Geocoding';

export default {
  components: {
    MainTitle,
    StoreLocatorAroundMe,
    StoreLocatorMap,
    StoreLocatorStoreCard,
  },
  props: {
    stores: {
      type: Array,
      required: true,
    },
    defaultMapPosition: {
      type: Object,
      required: true,
    },
    defaultMapBounds: {
      type: Array,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentPosition: null,
      currentStore: null,
    };
  },
  computed: {
    /**
     * @return {Array}
     */
    orderedStores() {
      return [...this.stores].sort((storeA, storeB) => {
        if (this.currentStore) {
          if (storeA.id === this.currentStore.id) {
            return -1;
          }

          if (storeB.id === this.currentStore.id) {
            return 1;
          }
        }

        if (this.currentPosition) {
          const latLng = [
            this.currentPosition.latitude,
            this.currentPosition.longitude,
          ];

          return (
            haversineDistance(latLng, [storeA.latitude, storeA.longitude]) -
            haversineDistance(latLng, [storeB.latitude, storeB.longitude])
          );
        }

        return storeA.name.localeCompare(storeB.name);
      });
    },
  },
  methods: {
    /**
     * @param {{latitude: number, longitude: number}}
     */
    setCurrentPosition({ latitude, longitude }) {
      this.currentPosition = {
        latitude,
        longitude,
      };
    },
    /**
     * @param {Object} store
     */
    setCurrentStore(store) {
      this.currentStore = store;
    },
    /**
     * @param {{latitude: number, longitude: number}}
     * @return {Object}
     */
    getNearestStore({ latitude, longitude }) {
      const latLng = [latitude, longitude];

      return [...this.stores].sort((storeA, storeB) => {
        return (
          haversineDistance(latLng, [storeA.latitude, storeA.longitude]) -
          haversineDistance(latLng, [storeB.latitude, storeB.longitude])
        );
      })[0];
    },
  },
  mounted() {
    const address = Url.getParam('address');

    if ((address || '').length > 0) {
      Geocoding.geocodeAddress(address).then((position) => {
        this.setCurrentPosition(position);
        this.setCurrentStore(this.getNearestStore(position));
      });
    }
  },
};
